// extracted by mini-css-extract-plugin
export default {"contentGrid":"contentGrid_contentGrid__kEaXJ","contentGrid__block":"contentGrid_contentGrid__block__TNU9T"};